// @ts-nocheck
import cx from 'helpers/cx'

import CoverImage from 'js/components/CoverImage'
import { Container } from 'js/components/Grid'
import { H1 } from 'js/components/Heading'
import ItemTags from 'js/components/ItemTags'
import TiptapView from 'js/components/Tiptap/TiptapView'

import styles from './VersionPreview.module.css'

const VersionPreview = ({ site, entity, className, ...rest }) => {
    const { featured, title, richDescription, tags, tagCategories } = entity

    return (
        <div {...rest} className={cx(styles.wrapper, className)}>
            {featured && (
                <Container size="large" className={styles.coverContainer}>
                    <CoverImage featured={featured} />
                </Container>
            )}
            <Container
                size="normal"
                style={{ paddingTop: '32px', paddingBottom: '32px' }}
            >
                <H1
                    style={{
                        order: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                    }}
                >
                    {title}
                </H1>

                <TiptapView
                    content={richDescription}
                    style={{ marginTop: '24px' }}
                />

                <ItemTags
                    showCustomTags={site.showCustomTagsInDetail}
                    showTags={site.showTagsInDetail}
                    customTags={tags}
                    tagCategories={tagCategories}
                    style={{ marginTop: '24px' }}
                />
            </Container>
        </div>
    )
}

export default VersionPreview
